import { ClickReleaseInstance, type InitOptions } from './core/sdk';

/** Create a ClickRelease SDK instance. `init()` takes identity, fetch options, and presentation `config` — see DESIGN.md. */
export function init(options: InitOptions): ClickReleaseInstance {
  return new ClickReleaseInstance(options);
}

export const version = '0.0.0';

export { ClickReleaseInstance } from './core/sdk';
export type { InitOptions, BannerApi } from './core/sdk';
export type {
  ClickReleaseConfig,
  ConfigOverride,
  DeepPartial,
  SurfaceKind,
  Corner,
  BadgeMode,
  BannerPlacement,
  ThemeMode,
  ReducedMotionMode,
  IndicatorConfig,
  ToastConfig,
  BannerConfig,
  ThemeConfig,
  ThemeColors,
} from './config/types';
export type { ReleaseEntry } from './content/types';
export type { ContentSource, RemoteSourceOptions } from './content/sources';
export type { SeenStore } from './state/seen-store';
export type { CrEvent, Handler } from './core/events';
